export type HeadsetFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type HeadsetFilterGroup = {
  id: string;
  label: string;
  options: HeadsetFilterOption[];
};

export const headsetFilterGroups: HeadsetFilterGroup[] = [
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: 'logitech', label: 'Logitech', keywords: ['logitech'] },
      { value: 'razer', label: 'Razer', keywords: ['razer'] },
      { value: 'steelseries', label: 'SteelSeries', keywords: ['steelseries'] },
      { value: 'corsair', label: 'Corsair', keywords: ['corsair'] },
      { value: 'hyperx', label: 'HyperX', keywords: ['hyperx'] },
      { value: 'asus', label: 'ASUS', keywords: ['asus', 'rog', 'tuf'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
      { value: 'gigabyte-aorus', label: 'GIGABYTE AORUS', keywords: ['gigabyte', 'aorus'] },
      { value: 'cooler-master', label: 'Cooler Master', keywords: ['cooler master'] },
      { value: 'zowie', label: 'ZOWIE', keywords: ['zowie'] },
      { value: 'akko', label: 'Akko', keywords: ['akko'] },
      { value: 'rapoo', label: 'Rapoo', keywords: ['rapoo'] },
      { value: 'dareu', label: 'Dareu', keywords: ['dareu'] },
      { value: 'e-dra', label: 'E Dra', keywords: ['e-dra', 'edra'] },
      { value: 'alienware', label: 'Alienware', keywords: ['alienware'] },
    ],
  },
  {
    id: 'led',
    label: 'Loại LED',
    options: [
      { value: 'rgb', label: 'RGB LED', keywords: ['rgb'] },
      { value: 'single', label: 'Đơn LED', keywords: ['led don', 'single led'] },
      { value: 'rainbow', label: 'Rainbow LED', keywords: ['rainbow led', 'led rainbow'] },
      { value: 'none', label: 'Không LED', keywords: ['khong led', 'no led'] },
    ],
  },
  {
    id: 'connectivity',
    label: 'Kết nối',
    options: [
      { value: 'wired', label: 'Có Dây', keywords: ['co day', 'wired', 'usb', '3.5mm'] },
      { value: 'wireless', label: 'Wireless', keywords: ['wireless', '2.4ghz'] },
      { value: 'bluetooth', label: 'Bluetooth', keywords: ['bluetooth'] },
      { value: 'true-wireless', label: 'True Wireless', keywords: ['true wireless', 'tws'] },
    ],
  },
  {
    id: 'type',
    label: 'Loại tai nghe',
    options: [
      { value: 'overear', label: 'Overear', keywords: ['over-ear', 'overear', 'chup tai'] },
      { value: 'inear', label: 'Inear', keywords: ['in-ear', 'inear', 'nhet tai'] },
      { value: 'earbud', label: 'Earbud', keywords: ['earbud'] },
      { value: 'onear', label: 'Onear', keywords: ['on-ear', 'onear'] },
    ],
  },
  {
    id: 'micro',
    label: 'Micro',
    options: [
      {
        value: 'has-mic',
        label: 'Có Mic',
        keywords: ['co mic', 'with mic', 'built-in mic', 'microphone'],
      },
      { value: 'no-mic', label: 'Không Mic', keywords: ['khong mic', 'no mic', 'no microphone'] },
    ],
  },
];
